import * as React from "react";
import { JSX } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface ListAccordionProps {
  children?: React.ReactNode;
  defaultOpen?: boolean;
  titleElement: JSX.Element;
}

interface ListAccordionState {
  open: boolean;
}

/**
 * This component is intended to render as a bunch of nested collapsible lists. Initial implementation is in CreateProjectStepReview.tsx.
 * The top level one should be wrapped in a <ul /> for HTML compliance.
 * @property defaultOpen Determines whether the accordion is expanded on initial render
 * @property titleElement The top component, wrapped in an <li />
 */
export default class ListAccordion extends React.Component<ListAccordionProps, ListAccordionState> {
  constructor(props: ListAccordionProps) {
    super(props);
    this.state = {
      open: props.defaultOpen || false,
    };
  }

  public render() {
    const hasChildren = React.Children.count(this.props.children) > 0;
    return (
      <React.Fragment>
        <li
          className={`list-accordion-title ${hasChildren ? "list-accordion-parent" : ""} ${this.state.open ? "open" : ""}`}
          onClick={(e) => this.handleClick(e)}
        >
          {this.props.titleElement}
          {hasChildren ? (
            <React.Fragment>
              <span className="list-accordion-indicator"><QesIcon iconName={QesIcons.ChevronRight} description={this.state.open ? "Collapse" : "Expand"} /></span>
              <ul
                className="list-accordion"
              >
                {this.props.children}
              </ul>
            </React.Fragment>
          ) : null
          }
        </li>
      </React.Fragment>
    );
  }

  private handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    this.setState((prevState) => ({
      open: !prevState.open,
    }));
  }
}
